import React from "react"
import WeightStyle from "./WeightStyle.module.css"
import translate, { keys } from "../../../../../translation/translator"

const Weight = ({ handleChangeWeight, weight, locale, units }) => {
  return (
    <div className={WeightStyle.holder}>
      <p className={WeightStyle.weight_title}>
        3. {translate(keys.WHAT_IS_YOUR_WEIGHT, locale)}
      </p>
      {units === "Metric" ? (
        <div className={WeightStyle.input_holder}>
          <input
            value={weight}
            onChange={handleChangeWeight}
            type="text"
            placeholder={translate(keys.KG, locale)}
          />
          {weight.length > 0 ? (
            <span className={WeightStyle.placeholder}>
              {translate(keys.KG, locale)}
            </span>
          ) : null}
        </div>
      ) : (
        <div className={WeightStyle.input_holder}>
          <input
            value={weight}
            onChange={handleChangeWeight}
            type="text"
            placeholder={translate(keys.LB, locale)}
          />
          {weight.length > 0 ? (
            <span className={WeightStyle.placeholder}>
              {translate(keys.LB, locale)}
            </span>
          ) : null}
        </div>
      )}
      <React.Fragment>
        {units === "Metric" ? (
          <React.Fragment>
            {weight < 30 || weight > 220 ? (
              <div className={WeightStyle.weight_popup}>
                <span>{translate(keys.KG_POPUP, locale)}</span>
              </div>
            ) : null}
          </React.Fragment>
        ) : (
          <React.Fragment>
            {weight < 66 || weight > 485 ? (
              <div className={WeightStyle.weight_popup}>
                <span>{translate(keys.LB_POPUP, locale)}</span>
              </div>
            ) : null}
          </React.Fragment>
        )}
      </React.Fragment>
    </div>
  )
}

export default Weight
